module.exports = __webpack_public_path__ + "static/img/load.5103668.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/load.gif
// module id = ZWQh
// module chunks = 1